module.exports = __webpack_public_path__ + "909e257625365b64c7bc3a30b1bd3766.svg";